import * as yup from 'yup'

const schema = yup.object().shape({
  companyId: yup.object().required('Selecione uma empresa').nullable(),
})

export default schema
